import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/contact_add_icon.png'
import _imports_1 from '@/assets/images/file_icon.png'
import _imports_2 from '../assets/icon/note_icon.svg'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "contents_div" }
const _hoisted_4 = { class: "detail_table" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "font-bold flex_td" }
const _hoisted_8 = {
  colspan: "3",
  class: "font-bold"
}
const _hoisted_9 = { class: "flex_td" }
const _hoisted_10 = { class: "flex_td" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = { style: {"display":"flex","flex-direction":"column","justify-content":"center"} }
const _hoisted_14 = { colspan: "3" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "contact_wrap" }
const _hoisted_17 = { class: "contact_outer_div" }
const _hoisted_18 = { class: "pay_info_wrap" }
const _hoisted_19 = { class: "order_box" }
const _hoisted_20 = {
  style: {"border-right":"2px solid #dbdbdb"},
  class: "box_title"
}
const _hoisted_21 = {
  style: {"border-right":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_22 = { class: "pay_gubun" }
const _hoisted_23 = {
  style: {"border-right":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_24 = { class: "pay_date" }
const _hoisted_25 = { class: "flex_wrap" }
const _hoisted_26 = { class: "pay_rate" }
const _hoisted_27 = {
  style: {"border-left":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_28 = { class: "pay_amt" }
const _hoisted_29 = {
  key: 0,
  style: {"border-right":"2px solid #dbdbdb","justify-content":"center","min-height":"59px"},
  class: "box_inp_wrap"
}
const _hoisted_30 = { class: "receive_execution_box" }
const _hoisted_31 = { class: "box_title" }
const _hoisted_32 = {
  style: {"border-right":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_33 = { class: "pay_gubun" }
const _hoisted_34 = {
  style: {"border-right":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_35 = { class: "pay_date" }
const _hoisted_36 = {
  style: {"border-right":"1px solid #dbdbdb"},
  class: "flex_wrap"
}
const _hoisted_37 = { class: "pay_rate" }
const _hoisted_38 = {
  style: {"border-right":"1px solid #dbdbdb","padding-right":"10px"},
  class: "flex_wrap"
}
const _hoisted_39 = { class: "pay_amt" }
const _hoisted_40 = {
  key: 0,
  class: "flex_wrap"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 2,
  style: {"color":"#3382e9","padding":"5px 10px"}
}
const _hoisted_44 = {
  key: 1,
  class: "flex_wrap"
}
const _hoisted_45 = {
  key: 0,
  style: {"justify-content":"center","min-height":"59px"},
  class: "box_inp_wrap"
}
const _hoisted_46 = { class: "contact_outer_div" }
const _hoisted_47 = { class: "contact_div" }
const _hoisted_48 = { class: "contact_header" }
const _hoisted_49 = { class: "contact_ul" }
const _hoisted_50 = { class: "contact_li" }
const _hoisted_51 = { class: "contact_nm" }
const _hoisted_52 = { class: "contact_tel" }
const _hoisted_53 = { class: "contact_tel" }
const _hoisted_54 = { class: "contact_tel" }
const _hoisted_55 = { class: "contact_tel" }
const _hoisted_56 = { class: "contact_li" }
const _hoisted_57 = { class: "contact_nm" }
const _hoisted_58 = { class: "contact_tel" }
const _hoisted_59 = { class: "contact_tel" }
const _hoisted_60 = { class: "contact_tel" }
const _hoisted_61 = { class: "contact_tel" }
const _hoisted_62 = { class: "contact_li" }
const _hoisted_63 = { class: "contact_nm" }
const _hoisted_64 = { class: "contact_tel" }
const _hoisted_65 = { class: "contact_tel" }
const _hoisted_66 = { class: "contact_tel" }
const _hoisted_67 = { class: "contact_tel" }
const _hoisted_68 = { class: "contact_outer_div" }
const _hoisted_69 = { class: "contact_div" }
const _hoisted_70 = { class: "contact_header" }
const _hoisted_71 = { class: "contact_ul" }
const _hoisted_72 = { class: "contact_li" }
const _hoisted_73 = { class: "contact_nm" }
const _hoisted_74 = { class: "contact_tel" }
const _hoisted_75 = { class: "contact_tel" }
const _hoisted_76 = { class: "contact_tel" }
const _hoisted_77 = { class: "contact_tel" }
const _hoisted_78 = { class: "contact_li" }
const _hoisted_79 = { class: "contact_nm" }
const _hoisted_80 = { class: "contact_tel" }
const _hoisted_81 = { class: "contact_tel" }
const _hoisted_82 = { class: "contact_tel" }
const _hoisted_83 = { class: "contact_tel" }
const _hoisted_84 = { class: "contact_li" }
const _hoisted_85 = { class: "contact_nm" }
const _hoisted_86 = { class: "contact_tel" }
const _hoisted_87 = { class: "contact_tel" }
const _hoisted_88 = { class: "contact_tel" }
const _hoisted_89 = { class: "contact_tel" }
const _hoisted_90 = { class: "page_header" }
const _hoisted_91 = { class: "file_ul" }
const _hoisted_92 = { class: "file_gubn" }
const _hoisted_93 = { class: "file_name_div" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "file_btn_group" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  key: 0,
  class: "file_li"
}
const _hoisted_99 = {
  key: 1,
  class: "file_li_wrap"
}
const _hoisted_100 = { class: "page_header" }
const _hoisted_101 = { class: "file_ul" }
const _hoisted_102 = { class: "file_gubn" }
const _hoisted_103 = { class: "file_name_div" }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { class: "file_btn_group" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = ["onClick"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = {
  key: 0,
  class: "file_li"
}
const _hoisted_111 = {
  key: 1,
  class: "file_li_wrap"
}
const _hoisted_112 = { class: "note_icon_box" }
const _hoisted_113 = {
  key: 0,
  class: "count_box"
}

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import FileUploadPop from "@/components/popup/FileUploadPop.vue";
import FileRequestPop from "@/components/popup/FileRequestPop.vue";
import ContactPop from "@/components/popup/ContactPop.vue";
import PaymentInfoPop from "@/components/popup/PaymentInfoPop.vue";
import NotePop from "@/components/popup/NotePop.vue";
import StatusPop from "@/components/popup/StatusPop.vue";
import PDFSealPop from "@/components/popup/PDFSealPop.vue";
import SealConsentPop from "@/components/popup/SealConsentPop.vue";
import ContractListPop from "@/components/popup/ContractListPop.vue";
import ContractPop from "@/components/popup/ContractPop.vue";
import announceAPI from "@/api/announceAPI";
import { Announce, ApiResponse, AnnounceFile, ClosePopupOptions, Member, PaymentInfo, Contract } from "../common/types";
import { numberFormat } from "@/utils/utils";
import { userStore } from "@/store/userStore";
import codeAPI from "@/api/codeAPI";

export default /*@__PURE__*/_defineComponent({
  __name: 'AnnounceDetailView',
  setup(__props) {

const announceData = ref<Announce>({
  공고순번: 0,
  공고번호: "",
  공고기관: "",
  발주처: "",
  공고명: "",
  낙찰금액: 0,
  수행금액: 0,
  수행상태: "",
  노출여부: "",
  진행여부: "",
  수주수행구분: "",
  수주회원: {} as Member, // Member 타입에 맞게 설정
  수행회원: {} as Member, // Member 타입에 맞게 설정
  낙찰일: "",
  착수일: "",
  계약시작일: "",
  계약종료일: "",
  선금여부: "",
  수주담당자이름1: "",
  수주담당자이름2: "",
  수주담당자이름3: "",
  수주담당자전화번호1: "",
  수주담당자전화번호2: "",
  수주담당자전화번호3: "",
  수주담당자직통번호1: "",
  수주담당자직통번호2: "",
  수주담당자직통번호3: "",
  수주담당자이메일1: "",
  수주담당자이메일2: "",
  수주담당자이메일3: "",
  수주담당자비고1: "",
  수주담당자비고2: "",
  수주담당자비고3: "",
  수행담당자이름1: "",
  수행담당자이름2: "",
  수행담당자이름3: "",
  수행담당자전화번호1: "",
  수행담당자전화번호2: "",
  수행담당자전화번호3: "",
  수행담당자직통번호1: "",
  수행담당자직통번호2: "",
  수행담당자직통번호3: "",
  수행담당자이메일1: "",
  수행담당자이메일2: "",
  수행담당자이메일3: "",
  수행담당자비고1: "",
  수행담당자비고2: "",
  수행담당자비고3: "",
  원공고링크: "",
  비고: "",
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  수주첨부파일들: [],
  수행첨부파일들: [],
  수주계약서작성여부: true,
  수행계약서작성여부: true,
  공고대금지급정보: [] as PaymentInfo[],
  메모신규건수: 0,
  계약서: {} as Contract,
  사용인감사용여부: false,
});
const router = useRouter();
const formatCurrency = (value: number): string => {
  return value.toLocaleString();
};
const 공고순번 = ref<number | null>(null);
const 요청파일정보 = ref<{ 요청순번: number | null; 파일제목: string | null }>({
  요청순번: null,
  파일제목: null,
});
const 수주수행구분 = ref<string | null>(null);
const 발주처수주구분 = ref<string | null>(null);
const toggleFileUploadPop = ref(false);
const toggleFileRequestPop = ref(false);
const toggleContactPop = ref(false);
const togglePaymentInfoPop = ref(false);
const toggleStatusPop = ref(false);
const togglePDFPop = ref(false);
const toggleSealConsentPop = ref(false);
const toggleContactListPop = ref(false);
const contractFlag = ref(false);
const store = userStore();
const 구분목록: any = ref([]);
onMounted(() => {
  codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data
  });
  공고순번.value = Number(router.currentRoute.value.params.seq);
  getDetail();
});

const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  announceAPI.announceDetail(seq).then((res) => {
    const detailData = res.data.data;
    const 선금여부 = detailData.선금여부 ? "유" : "무";

    const formatPhoneNumber = (phone: string): string => {
      if (!phone) return ""; // 번호가 없으면 빈 문자열 반환
      return phone.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
    };

    // announceData 업데이트 (수주/수행 파일 분리 포함)
    announceData.value = {
      ...detailData,
      선금여부,
      수주첨부파일들: detailData.첨부파일목록.filter((file: any) => file.자료식별값2 == "수주"),
      수행첨부파일들: detailData.첨부파일목록.filter((file: any) => file.자료식별값2 == "수행"),
      수주담당자전화번호1: formatPhoneNumber(detailData.수주담당자전화번호1),
      수주담당자전화번호2: formatPhoneNumber(detailData.수주담당자전화번호2),
      수주담당자전화번호3: formatPhoneNumber(detailData.수주담당자전화번호3),
      수행담당자전화번호1: formatPhoneNumber(detailData.수행담당자전화번호1),
      수행담당자전화번호2: formatPhoneNumber(detailData.수행담당자전화번호2),
      수행담당자전화번호3: formatPhoneNumber(detailData.수행담당자전화번호3),
    };
  });
};

const openFileUploadPop = (type: string, reqNumber?: number | null, fileTitle?: string | null) => {
  수주수행구분.value = type;
  요청파일정보.value = {
    요청순번: reqNumber ?? null,
    파일제목: fileTitle ?? null,
  };

  toggleFileUploadPop.value = true;
};
const 회원구분 = ref<string>("")
const openContactPopList = () => {
  if(store.userInfo.회원순번 == announceData.value.수주회원.회원순번) {
    회원구분.value = "수주"
  } else if(store.userInfo.회원순번 == announceData.value.수행회원.회원순번) {
    회원구분.value = "수행"
  } else {
    alert("수주/수행 업체의 계약이력을 확인할 수 없습니다.")
    return
  }
  toggleContactListPop.value = true;
};
const openContactPop = (type: string) => {
  수주수행구분.value = type;
  toggleContactPop.value = true;
};
const openPaymentInfoPop = (type: string) => {
  발주처수주구분.value = type;
  togglePaymentInfoPop.value = true;
};
const openFileRequestPop = (type: string) => {
  수주수행구분.value = type;
  toggleFileRequestPop.value = true;
};
const contractClose = () => {
  contractFlag.value = false;
};
const seq2 = ref<number | null>(null);
const contract = ref<Contract | null>(null);
const contractType = ref("R")
const openContractPop = (data: Contract) => {
  seq2.value = data.저장파일!.저장순번!;
  contract.value = data;
  if(data[`${회원구분.value}계약서작성여부`]) {
    contractType.value = "R"
  } else {
    contractType.value = "U"
  }
  contractFlag.value = true;
};
const paymentCheck = (info: PaymentInfo) => {
  if (confirm("지급금액을 확인하셨습니까?")) {
    
    announceAPI.savePayment(announceData.value.공고순번, {
      공고대금지급정보등록: [],
      공고대금지급정보수정: [{지급순번:info.지급순번,수행회원금액확인: true}],
      공고대금지급정보삭제: [],
    }).then(() => {
      getDetail()
    });
  }
};
const paymentConfirm = (info: PaymentInfo) => {
  if (confirm("입금을 확인하셨습니까?")) {
    announceAPI.savePayment(announceData.value.공고순번, {
      공고대금지급정보등록: [],
      공고대금지급정보수정: [{지급순번:info.지급순번,수행회원입금확인: true}],
      공고대금지급정보삭제: [],
    }).then(() => {
      getDetail()
    });
  }
};
const closePopup = ({ popupType, refresh, selectedData }: ClosePopupOptions) => {
  if (popupType === "fileUpload") toggleFileUploadPop.value = false;
  else if (popupType === "contact") toggleContactPop.value = false;
  else if (popupType === "contractList") toggleContactListPop.value = false;
  else if (popupType === "status") {
    toggleStatusPop.value = false;
    if (selectedData) {
      announceData.value = { ...announceData.value, 수행상태: selectedData };
    }
    if(currentStatus.value !== selectedData && refresh) {
      announceAPI.modifyContact({ 수행상태: selectedData },공고순번.value!).then((res) => {
        if (res.data.success) {
          alert("수행상태가 변경되었습니다.");
        } else {
          alert("수행상태 변경에 실패했습니다.");
        }
      });
    } else {
      announceData.value.수행상태 = currentStatus.value!
    }
    // 수행상태 변경 팝업에서는 새로고침하지 않음
    return;
  } else if (popupType === "fileRequest") toggleFileRequestPop.value = false;
  else if(popupType === "consent") {
    toggleSealConsentPop.value = false;
    if(!selectedData) return
    announceAPI.modifyContact({ 사용인감사용여부: selectedData },공고순번.value!).then((res) => {
      if (res.data.success) {
        alert("사용인감 사용에대해 동의하셨습니다.");
        announceData.value.사용인감사용여부 = selectedData as unknown as boolean;
      }
    });
  }
  if (refresh) {
    getDetail();
  }
};

const closePaymentInfoPopup = () => {
  togglePaymentInfoPop.value = false;
};
const selectedFile = ref<AnnounceFile | null>();
const selectedTitle = ref<string | null>(null);
const pdfCall = (첨부파일: AnnounceFile) => {
  selectedFile.value = 첨부파일;
  selectedTitle.value = 구분목록.value.filter((dto:any) => dto.코드 == 첨부파일.파일제목)[0].코드명
  togglePDFPop.value = true;
}
const deleteFile = (첨부파일: AnnounceFile) => {
  if (confirm("첨부파일을 삭제 하시겠습니까?")) {
    const 공고순번 = announceData.value.공고순번;
    const 저장순번 = 첨부파일.저장순번; // 첨부파일 객체에서 저장순번을 가져옴

    if (!공고순번 || !저장순번) {
      alert("파일 삭제에 필요한 정보가 누락되었습니다.");
      return;
    }

    announceAPI
      .deleteAnnounceFile(공고순번, 저장순번)
      .then((res: ApiResponse) => {
        if (res.success) {
          alert("삭제가 완료되었습니다.");
          getDetail(); // 삭제 후 목록 갱신
        } else {
          alert("첨부파일 삭제에 실패했습니다.");
        }
      })
      .catch((error) => {
        alert("첨부파일 삭제 중 오류가 발생했습니다.");
      });
  }
};

const getFile = (공고순번: number, 저장순번: number | undefined, 파일명: string) => {
  if (저장순번 === undefined || 저장순번 === null) {
    alert("파일 정보를 불러올 수 없습니다. 다시 시도해주세요.");
    return;
  }

  announceAPI.downloadAnnounceFile(공고순번, 저장순번, 파일명);
};
const getFiles = (수주수행구분:string) => {
  announceAPI.downloadAllAnnounceFile(announceData.value, 수주수행구분);
}
// 수행상태 변경 팝업 open
const currentStatus = ref<string | null>(null);
const openStatusPop = (status: string) => {
  currentStatus.value = status;
  toggleStatusPop.value = true;
};
const calculateMarginRate = (bidAmount: number, performanceAmount: number): string => {
  if (bidAmount === 0) return "0%";
  const marginRate = ((bidAmount - performanceAmount) / bidAmount) * 100;
  return `${marginRate.toFixed(2)}%`;
};
// const calculateVAT = (수행금액: number): string => {
//   const 부가세 = 수행금액 * 0.1; // 부가세 계산

//   // 세 자리마다 콤마 추가
//   return 부가세.toLocaleString("ko-KR");
// };
const calculateMarginAmount = (bidAmount: number, performanceAmount: number): string => {
  const marginAmount = bidAmount - performanceAmount;
  return `${numberFormat(marginAmount)}원`;
};
// NotePop 표시 여부를 관리하는 상태 변수
const toggleNotePop = ref<boolean>(false); // ref의 타입을 boolean으로 명시

// NotePop을 여는 함수
const openNotePop = (): void => {
  toggleNotePop.value = true;
};

// NotePop을 닫는 함수
const closeNotepop = (): void => {
  toggleNotePop.value = false;
};
const closePDFpop = () => {
  togglePDFPop.value = false;
  selectedFile.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "page_header" }, [
            _createElementVNode("div", { class: "page_header_circle" }),
            _createTextVNode(" 공고상세 ")
          ], -1)),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "table_label" }, "공고기관", -1)),
                _createElementVNode("td", _hoisted_5, _toDisplayString(announceData.value.공고기관), 1),
                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "table_label" }, "공고번호", -1)),
                _createElementVNode("td", null, _toDisplayString(announceData.value.공고번호), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "table_label" }, "발주처", -1)),
                _createElementVNode("td", _hoisted_6, _toDisplayString(announceData.value.발주처), 1),
                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "table_label" }, "수행상태", -1)),
                _createElementVNode("td", _hoisted_7, [
                  _createTextVNode(_toDisplayString(announceData.value.수행상태) + " ", 1),
                  (announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "contact_add_btn",
                        src: _imports_0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openStatusPop(announceData.value.수행상태 || '')))
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "table_label" }, "공고명", -1)),
                _createElementVNode("td", _hoisted_8, _toDisplayString(announceData.value.공고명), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "table_label" }, "낙찰금액", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(numberFormat)(announceData.value.낙찰금액)) + "원", 1),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "table_label" }, "수행금액", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(numberFormat)(announceData.value.수행금액)) + "원", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "table_label" }, "마진금액", -1)),
                _createElementVNode("td", null, _toDisplayString(calculateMarginAmount(announceData.value.낙찰금액, announceData.value.수행금액)) + " (" + _toDisplayString(calculateMarginRate(announceData.value.낙찰금액, announceData.value.수행금액)) + ")", 1),
                _cache[23] || (_cache[23] = _createElementVNode("td", { class: "table_label" }, "낙찰일", -1)),
                _createElementVNode("td", null, _toDisplayString(announceData.value.낙찰일), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "table_label" }, "수주업체", -1)),
                _createElementVNode("td", _hoisted_9, [
                  _createTextVNode(_toDisplayString(announceData.value.수주회원?.사업자명) + " ", 1),
                  (announceData.value.수주회원.사업자등록증)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        title: "사업자등록증 다운로드",
                        src: _imports_1,
                        style: {"cursor":"pointer"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (getFile(announceData.value.공고순번, announceData.value.수주회원.사업자등록증.저장순번, announceData.value.수주회원.사업자등록증.원파일명)))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("td", { class: "table_label" }, "수행업체", -1)),
                _createElementVNode("td", _hoisted_10, [
                  _createTextVNode(_toDisplayString(announceData.value.수행회원?.사업자명) + " ", 1),
                  (announceData.value.수행회원.사업자등록증)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        title: "사업자등록증 다운로드",
                        src: _imports_1,
                        style: {"cursor":"pointer"},
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (getFile(announceData.value.공고순번, announceData.value.수행회원.사업자등록증.저장순번, announceData.value.수행회원.사업자등록증.원파일명)))
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[26] || (_cache[26] = _createElementVNode("td", { class: "table_label" }, "착수일", -1)),
                _createElementVNode("td", null, _toDisplayString(announceData.value.착수일), 1),
                _cache[27] || (_cache[27] = _createElementVNode("td", { class: "table_label" }, "계약기간", -1)),
                _createElementVNode("td", null, _toDisplayString(announceData.value.계약시작일) + " ~ " + _toDisplayString(announceData.value.계약종료일), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[28] || (_cache[28] = _createElementVNode("td", { class: "table_label" }, "공고 링크", -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    style: {"color":"blue","text-decoration":"underline"},
                    href: announceData.value.원공고링크,
                    target: "_blank"
                  }, "공고 보러 가기", 8, _hoisted_11)
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "table_label" }, "계약서", -1)),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      style: {"color":"blue","text-decoration":"underline","cursor":"pointer"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (getFile(announceData.value.공고순번, announceData.value.계약서?.저장파일?.저장순번, announceData.value.계약서?.저장파일?.원파일명)))
                    }, _toDisplayString(announceData.value.계약서?.저장파일?.원파일명), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 ? announceData.value.계약서?.수주계약서작성여부 ? 
                    '':'수주업체 계약서 작성 전' : announceData.value.계약서?.수행계약서작성여부 ? '':'수행업체 계약서 작성 전'), 1)
                  ]),
                  _createElementVNode("div", {
                    style: {"margin-left":"auto","background":"#3382e9","padding":"5px 10px","color":"#fff","font-weight":"500","cursor":"pointer"},
                    onClick: openContactPopList
                  }, "계약이력")
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[30] || (_cache[30] = _createElementVNode("td", { class: "table_label" }, "비고", -1)),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("div", {
                    style: {"height":"100px","overflow-y":"auto","width":"100%"},
                    innerHTML: announceData.value.비고.replace(/\n/g, '<br>')
                  }, null, 8, _hoisted_15)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "contact_title" }, "대금지급 정보", -1)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[31] || (_cache[31] = _createTextVNode(" 발주처 대금지급정보 ")),
                    (announceData.value.진행여부 && _unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "contact_add_btn pay_mod_btn",
                          src: _imports_0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (openPaymentInfoPop('발주처')))
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announceData.value.공고대금지급정보.filter((item) => item.발주처수주구분 === '발주처'), (info, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `발주처-${index}`,
                      style: {"border-right":"2px solid #dbdbdb"},
                      class: "box_inp_wrap"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(info.지급구분), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(info.지급일자), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(info.지급율), 1),
                        _cache[32] || (_cache[32] = _createElementVNode("div", null, "%", -1))
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(formatCurrency(info.지급금액)), 1),
                        _cache[33] || (_cache[33] = _createElementVNode("div", null, "원", -1))
                      ])
                    ]))
                  }), 128)),
                  (announceData.value.공고대금지급정보.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[34] || (_cache[34] = [
                        _createElementVNode("div", {
                          style: {"font-family":"'Noto Sans CJK KR-Regular'","font-size":"12px"},
                          class: "pay_amt"
                        }, "데이터가 없습니다.", -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[35] || (_cache[35] = _createTextVNode(" 수주/수행 대금지급정보 ")),
                    (announceData.value.진행여부 && _unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "contact_add_btn pay_mod_btn",
                          src: _imports_0,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (openPaymentInfoPop('수주')))
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announceData.value.공고대금지급정보.filter((item) => item.발주처수주구분 === '수주'), (info, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `수주-${index}`,
                      class: "box_inp_wrap"
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(info.지급구분), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(info.지급일자), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(info.지급율), 1),
                        _cache[36] || (_cache[36] = _createElementVNode("div", null, "%", -1))
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(formatCurrency(info.지급금액)), 1),
                        _cache[37] || (_cache[37] = _createElementVNode("div", null, "원", -1))
                      ]),
                      (announceData.value.진행여부 && _unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (!info.수행회원금액확인)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  style: {"background":"#383838","color":"#fff","padding":"5px 10px","cursor":"pointer"},
                                  onClick: ($event: any) => (paymentCheck(info))
                                }, " 금액 확인 ", 8, _hoisted_41))
                              : _createCommentVNode("", true),
                            (info.수행회원금액확인 && !info.수행회원입금확인)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  style: {"background":"#383838","color":"#fff","padding":"5px 10px","cursor":"pointer"},
                                  onClick: ($event: any) => (paymentConfirm(info))
                                }, " 입금 확인 ", 8, _hoisted_42))
                              : _createCommentVNode("", true),
                            (info.수행회원금액확인 && info.수행회원입금확인)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 입금 확인 완료 "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(store).userInfo.회원순번 === announceData.value.수주회원.회원순번 || !announceData.value.진행여부)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (!info.수행회원금액확인)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  style: _normalizeStyle([{"color":"#000","padding":"5px 10px"}, {color: info.수행회원금액확인 ? '#3382e9' : '#000'}])
                                }, " 금액 확인 " + _toDisplayString(info.수행회원금액확인 ? '완료' : '대기'), 5))
                              : _createCommentVNode("", true),
                            (info.수행회원금액확인)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  style: _normalizeStyle([{"color":"#000","padding":"5px 10px"}, {color: info.수행회원입금확인 ? '#3382e9' : '#000'}])
                                }, " 입금 확인 " + _toDisplayString(info.수행회원입금확인 ? '완료' : '대기'), 5))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (announceData.value.공고대금지급정보.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _cache[38] || (_cache[38] = [
                        _createElementVNode("div", {
                          style: {"font-family":"'Noto Sans CJK KR-Regular'","font-size":"12px"},
                          class: "pay_amt"
                        }, "데이터가 없습니다.", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "contact_title" }, "수주담당자 연락처", -1)),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _cache[40] || (_cache[40] = _createStaticVNode("<div class=\"contact_label\" data-v-3d4a8aa6>성함</div><div class=\"contact_label\" data-v-3d4a8aa6>연락처</div><div class=\"contact_label\" data-v-3d4a8aa6>직통번호</div><div class=\"contact_label\" data-v-3d4a8aa6>이메일</div><div class=\"contact_label\" data-v-3d4a8aa6>비고</div>", 5)),
                  (_unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "contact_add_btn",
                        src: _imports_0,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (openContactPop('수주')))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_49, [
                  _createElementVNode("li", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, _toDisplayString(announceData.value.수주담당자이름1), 1),
                    _createElementVNode("div", _hoisted_52, _toDisplayString(announceData.value.수주담당자전화번호1), 1),
                    _createElementVNode("div", _hoisted_53, _toDisplayString(announceData.value.수주담당자직통번호1), 1),
                    _createElementVNode("div", _hoisted_54, _toDisplayString(announceData.value.수주담당자이메일1), 1),
                    _createElementVNode("div", _hoisted_55, _toDisplayString(announceData.value.수주담당자비고1), 1)
                  ]),
                  _createElementVNode("li", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(announceData.value.수주담당자이름2), 1),
                    _createElementVNode("div", _hoisted_58, _toDisplayString(announceData.value.수주담당자전화번호2), 1),
                    _createElementVNode("div", _hoisted_59, _toDisplayString(announceData.value.수주담당자직통번호2), 1),
                    _createElementVNode("div", _hoisted_60, _toDisplayString(announceData.value.수주담당자이메일2), 1),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(announceData.value.수주담당자비고2), 1)
                  ]),
                  _createElementVNode("li", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, _toDisplayString(announceData.value.수주담당자이름3), 1),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(announceData.value.수주담당자전화번호3), 1),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(announceData.value.수주담당자직통번호3), 1),
                    _createElementVNode("div", _hoisted_66, _toDisplayString(announceData.value.수주담당자이메일3), 1),
                    _createElementVNode("div", _hoisted_67, _toDisplayString(announceData.value.수주담당자비고3), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "contact_title" }, "수행담당자 연락처", -1)),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"contact_label\" data-v-3d4a8aa6>성함</div><div class=\"contact_label\" data-v-3d4a8aa6>연락처</div><div class=\"contact_label\" data-v-3d4a8aa6>직통번호</div><div class=\"contact_label\" data-v-3d4a8aa6>이메일</div><div class=\"contact_label\" data-v-3d4a8aa6>비고</div>", 5)),
                  (_unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "contact_add_btn",
                        src: _imports_0,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (openContactPop('수행')))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_71, [
                  _createElementVNode("li", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, _toDisplayString(announceData.value.수행담당자이름1), 1),
                    _createElementVNode("div", _hoisted_74, _toDisplayString(announceData.value.수행담당자전화번호1), 1),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(announceData.value.수행담당자직통번호1), 1),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(announceData.value.수행담당자이메일1), 1),
                    _createElementVNode("div", _hoisted_77, _toDisplayString(announceData.value.수행담당자비고1), 1)
                  ]),
                  _createElementVNode("li", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, _toDisplayString(announceData.value.수행담당자이름2), 1),
                    _createElementVNode("div", _hoisted_80, _toDisplayString(announceData.value.수행담당자전화번호2), 1),
                    _createElementVNode("div", _hoisted_81, _toDisplayString(announceData.value.수행담당자직통번호2), 1),
                    _createElementVNode("div", _hoisted_82, _toDisplayString(announceData.value.수행담당자이메일2), 1),
                    _createElementVNode("div", _hoisted_83, _toDisplayString(announceData.value.수행담당자비고2), 1)
                  ]),
                  _createElementVNode("li", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(announceData.value.수행담당자이름3), 1),
                    _createElementVNode("div", _hoisted_86, _toDisplayString(announceData.value.수행담당자전화번호3), 1),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(announceData.value.수행담당자직통번호3), 1),
                    _createElementVNode("div", _hoisted_88, _toDisplayString(announceData.value.수행담당자이메일3), 1),
                    _createElementVNode("div", _hoisted_89, _toDisplayString(announceData.value.수행담당자비고3), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "page_header_circle" }, null, -1)),
            _cache[45] || (_cache[45] = _createTextVNode(" 수주업체 첨부파일 ")),
            _createElementVNode("div", {
              class: "all_download_btn",
              style: {"margin-left":"auto"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (getFiles('수주')))
            }, "전체 다운로드")
          ]),
          _createElementVNode("ul", _hoisted_91, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announceData.value.수주첨부파일들, (첨부파일) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "file_li",
                key: 첨부파일.공고첨부파일순번
              }, [
                _createElementVNode("div", _hoisted_92, _toDisplayString(구분목록.value.filter((dto) => dto.코드 == 첨부파일.파일제목)[0].코드명), 1),
                _createElementVNode("div", _hoisted_93, [
                  _cache[46] || (_cache[46] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                  _createElementVNode("div", {
                    class: "file_name",
                    onClick: ($event: any) => (getFile(announceData.value.공고순번, 첨부파일.저장순번, 첨부파일.원파일명))
                  }, _toDisplayString(첨부파일.원파일명), 9, _hoisted_94)
                ]),
                _createElementVNode("div", _hoisted_95, [
                  (첨부파일.원파일명 != null && _unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "delete_btn",
                        onClick: ($event: any) => (deleteFile(첨부파일))
                      }, "삭제", 8, _hoisted_96))
                    : _createCommentVNode("", true),
                  (첨부파일.원파일명 == null && _unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "delete_btn",
                        onClick: ($event: any) => (openFileUploadPop('수주', 첨부파일.요청순번, 첨부파일.파일제목 || null))
                      }, "업로드", 8, _hoisted_97))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (announceData.value.수주첨부파일들.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_98, _cache[47] || (_cache[47] = [
                  _createElementVNode("div", { style: {"margin":"0 auto"} }, "등록된 파일이 없습니다.", -1)
                ])))
              : _createCommentVNode("", true),
            (announceData.value.진행여부)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  (_unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "file_li add",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (openFileRequestPop('수주')))
                      }, _cache[48] || (_cache[48] = [
                        _createElementVNode("img", { src: _imports_1 }, null, -1),
                        _createTextVNode(" 파일 요청 + ")
                      ])))
                    : _createCommentVNode("", true),
                  (_unref(store).userInfo.회원순번 != announceData.value.수행회원.회원순번)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: "file_li add",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (openFileUploadPop('수주')))
                      }, _cache[49] || (_cache[49] = [
                        _createElementVNode("img", { src: _imports_1 }, null, -1),
                        _createTextVNode(" 파일 첨부 + ")
                      ])))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "page_header_circle" }, null, -1)),
            _cache[51] || (_cache[51] = _createTextVNode(" 수행업체 첨부파일 ")),
            (!announceData.value.사용인감사용여부 && _unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "consent_btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleSealConsentPop.value = true)),
                  style: {"margin-left":"auto"}
                }, "사용인감 동의서 작성"))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "all_download_btn",
              style: _normalizeStyle({marginLeft: announceData.value.사용인감사용여부 || _unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 ? 'auto':'none'}),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (getFiles('수행')))
            }, "전체 다운로드", 4)
          ]),
          _createElementVNode("ul", _hoisted_101, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announceData.value.수행첨부파일들, (첨부파일) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "file_li",
                key: 첨부파일.공고첨부파일순번
              }, [
                _createElementVNode("div", _hoisted_102, _toDisplayString(구분목록.value.filter((dto) => dto.코드 == 첨부파일.파일제목)[0].코드명), 1),
                _createElementVNode("div", _hoisted_103, [
                  _cache[52] || (_cache[52] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                  _createElementVNode("div", {
                    class: "file_name",
                    onClick: ($event: any) => (getFile(announceData.value.공고순번, 첨부파일.저장순번, 첨부파일.원파일명))
                  }, _toDisplayString(첨부파일.원파일명), 9, _hoisted_104)
                ]),
                _createElementVNode("div", _hoisted_105, [
                  (!첨부파일.요청순번)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                        (첨부파일.원파일명.indexOf('.pdf') != -1 && _unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 && announceData.value.진행여부 && announceData.value.사용인감사용여부)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "delete_btn",
                              onClick: ($event: any) => (pdfCall(첨부파일))
                            }, "날인", 8, _hoisted_107))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (첨부파일.원파일명 != null && _unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "delete_btn",
                        onClick: ($event: any) => (deleteFile(첨부파일))
                      }, "삭제", 8, _hoisted_108))
                    : _createCommentVNode("", true),
                  (첨부파일.원파일명 == null && _unref(store).userInfo.회원순번 == announceData.value.수행회원.회원순번 && announceData.value.진행여부)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "delete_btn",
                        onClick: ($event: any) => (openFileUploadPop('수행', 첨부파일.요청순번, 첨부파일.파일제목 || null))
                      }, "업로드", 8, _hoisted_109))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (announceData.value.수행첨부파일들.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_110, _cache[53] || (_cache[53] = [
                  _createElementVNode("div", { style: {"margin":"0 auto"} }, "등록된 파일이 없습니다.", -1)
                ])))
              : _createCommentVNode("", true),
            (announceData.value.진행여부)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  (_unref(store).userInfo.회원순번 == announceData.value.수주회원.회원순번)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "file_li add",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (openFileRequestPop('수행')))
                      }, _cache[54] || (_cache[54] = [
                        _createElementVNode("img", { src: _imports_1 }, null, -1),
                        _createTextVNode(" 파일 요청 + ")
                      ])))
                    : _createCommentVNode("", true),
                  (_unref(store).userInfo.회원순번 != announceData.value.수주회원.회원순번)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: "file_li add",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (openFileUploadPop('수행')))
                      }, _cache[55] || (_cache[55] = [
                        _createElementVNode("img", { src: _imports_1 }, null, -1),
                        _createTextVNode(" 파일 첨부 + ")
                      ])))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_112, [
        (announceData.value.메모신규건수 != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(announceData.value.메모신규건수), 1))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          src: _imports_2,
          alt: "",
          onClick: openNotePop
        }),
        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "note_text" }, "공고 메모", -1))
      ])
    ]),
    (toggleFileUploadPop.value)
      ? (_openBlock(), _createBlock(FileUploadPop, {
          key: 0,
          요청파일정보: 요청파일정보.value,
          공고순번: 공고순번.value,
          수주수행구분: 수주수행구분.value,
          onClosePopup: closePopup
        }, null, 8, ["요청파일정보", "공고순번", "수주수행구분"]))
      : _createCommentVNode("", true),
    (toggleFileRequestPop.value)
      ? (_openBlock(), _createBlock(FileRequestPop, {
          key: 1,
          공고순번: 공고순번.value,
          수주수행구분: 수주수행구분.value,
          onClosePopup: closePopup
        }, null, 8, ["공고순번", "수주수행구분"]))
      : _createCommentVNode("", true),
    (toggleContactPop.value)
      ? (_openBlock(), _createBlock(ContactPop, {
          key: 2,
          announceData: announceData.value,
          수주수행구분: 수주수행구분.value,
          onClosePopup: closePopup
        }, null, 8, ["announceData", "수주수행구분"]))
      : _createCommentVNode("", true),
    (togglePaymentInfoPop.value)
      ? (_openBlock(), _createBlock(PaymentInfoPop, {
          key: 3,
          announceData: announceData.value,
          발주처수주구분: 발주처수주구분.value,
          onGetDetail: getDetail,
          onClosePaymentInfoPopup: closePaymentInfoPopup
        }, null, 8, ["announceData", "발주처수주구분"]))
      : _createCommentVNode("", true),
    (toggleStatusPop.value)
      ? (_openBlock(), _createBlock(StatusPop, {
          key: 4,
          status: currentStatus.value,
          onClosePopup: closePopup
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    (toggleNotePop.value)
      ? (_openBlock(), _createBlock(NotePop, {
          key: 5,
          announceData: announceData.value,
          onGetDetail: getDetail,
          onCloseNotepop: closeNotepop
        }, null, 8, ["announceData"]))
      : _createCommentVNode("", true),
    (togglePDFPop.value)
      ? (_openBlock(), _createBlock(PDFSealPop, {
          key: 6,
          onClosePDFpop: closePDFpop,
          data: selectedFile.value!,
          title: selectedTitle.value!,
          공고순번: 공고순번.value!
        }, null, 8, ["data", "title", "공고순번"]))
      : _createCommentVNode("", true),
    (toggleSealConsentPop.value)
      ? (_openBlock(), _createBlock(SealConsentPop, {
          key: 7,
          onClosePopup: closePopup,
          사업자명: announceData.value.수행회원.사업자명
        }, null, 8, ["사업자명"]))
      : _createCommentVNode("", true),
    (toggleContactListPop.value)
      ? (_openBlock(), _createBlock(ContractListPop, {
          key: 8,
          onClosePopup: closePopup,
          onOpenContractPop: openContractPop,
          공고순번: 공고순번.value!,
          회원구분: 회원구분.value
        }, null, 8, ["공고순번", "회원구분"]))
      : _createCommentVNode("", true),
    (contractFlag.value)
      ? (_openBlock(), _createBlock(ContractPop, {
          key: 9,
          data: contract.value!,
          onClose: contractClose,
          seq: 공고순번.value!,
          seq2: seq2.value!,
          type: contractType.value
        }, null, 8, ["data", "seq", "seq2", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})